const validations = {
    isEmail: function(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }
};

const createErrorElement = (id, message) => {
    const errorElement = document.createElement('p');
    errorElement.id = `${id}-error`;
    errorElement.className = 'form__box__errortext';
    errorElement.style.display = 'block';
    errorElement.style.color = 'red';
    errorElement.style.whiteSpace = 'nowrap';
    errorElement.textContent = message;
    return errorElement;
};

function formValidator() {
    const inputs = this.querySelectorAll('input, select, textarea');
    let isValid = true;

    // Remove all previous error messages and error classes
    for (const input of inputs) {
        const errorElement = document.getElementById(`${input.id}-error`);
        if (errorElement) {
            errorElement.remove();
        }
        input.classList.remove('form__box__error');
    }

    // Validate all inputs
    inputs.forEach(input => {
        // Check required fields
        if (input.hasAttribute('required') && !input.value.trim()) {
            input.classList.add('form__box__error');
            const errorElement = createErrorElement(input.id, '入力してください。');

            // If is select, append error message after div.form__selectbox
            if (input.tagName.toLowerCase() === 'select') {
                const selectBox = input.closest('.form__selectbox');
                if (selectBox) {
                    selectBox.parentNode.appendChild(errorElement);
                }
            } else {
                input.parentNode.appendChild(errorElement);
            }

            isValid = false;
        }

        // Check email format if field is type="email"
        if (input.type === 'email' && input.value.trim()) {
            if (!validations.isEmail(input.value.trim())) {
                input.classList.add('form__box__error');
                const errorElement = createErrorElement(input.id, 'メールアドレスの形式が正しくありません。');
                input.parentNode.appendChild(errorElement);
                isValid = false;
            }
        }

        // Check tel format (半角数字とハイフンのみ)
        if (input.type === 'tel' && input.value.trim()) {
            const telRegex = /^[0-9-]+$/;
            if (!telRegex.test(input.value.trim())) {
                input.classList.add('form__box__error');
                const errorElement = createErrorElement(input.id, '電話番号が正しくありません。');
                input.parentNode.appendChild(errorElement);
                isValid = false;
            }
        }

        // Check order number format (半角数字のみ)
        if (input.id === 'ContactForm-ordernum' && input.value.trim()) {
            const regex = /^[0-9]+$/;
            if (!regex.test(input.value.trim())) {
                input.classList.add('form__box__error');
                const errorElement = createErrorElement(input.id, '注文番号は半角数字のみ入力してください。');
                input.parentNode.appendChild(errorElement);
                isValid = false;
            }
        }
    });

    return isValid;
}

document.querySelector('.contact__btn').addEventListener('click', function(event) {
    event.preventDefault();
    const form = this.closest('form');
    $('.contact__btn').prop('disabled', true);
    if (formValidator.call(form)) {
        //form.submit();
        const formData = Object.fromEntries(new FormData($('#ContactForm').get(0)));
        const contactUrl = mallDomain + '/admin/contact';
        fetchBase(contactUrl, (data) => {
            if (data.status === 200) {
                $('#message_success').show();
                $('#message_error').hide();
                $('.contact__btn').hide();
            } else {
                $('#message_success').hide();
                $('#message_error').show();
                $('.contact__btn').prop('disabled', false);
            }
        }, 'POST', formData);
    } else {
        // Enable button again if validation fails
        $('.contact__btn').prop('disabled', false);
    }
    return false;
});
